import LocalStorage from '../../../helpers/localStorageHelper';
import { localStorageKeys } from '../../../constants/localStorageKeys';
import { ActiveProgramAnnouncement } from './announcement';

/**
 * Event program id to the content of the announcement that was dismissed. A
 * per device preference like the Gift Aid nudge snooze, so it survives logout.
 * Storing the content rather than a flag means a system admin who rewrites the
 * announcement puts it back in front of charities that dismissed the old one.
 */
type DismissalMap = Record<string, unknown>;

const readDismissalMap = (): DismissalMap => {
  const stored: unknown = LocalStorage.getItem(
    localStorageKeys.PROGRAM_ANNOUNCEMENT_DISMISSALS
  );
  return typeof stored === 'object' && stored !== null && !Array.isArray(stored)
    ? (stored as DismissalMap)
    : {};
};

/** A stable string for the parts of the announcement a charity reads. */
export const getAnnouncementSignature = (
  announcement: ActiveProgramAnnouncement
): string =>
  JSON.stringify([
    announcement.title,
    announcement.description ?? '',
    announcement.callToAction?.label ?? '',
    announcement.callToAction?.href ?? ''
  ]);

/** True when this exact announcement was dismissed for this program. */
export const isAnnouncementDismissed = (
  programId: string,
  announcement: ActiveProgramAnnouncement
): boolean =>
  readDismissalMap()[programId] === getAnnouncementSignature(announcement);

/** Records a dismissal, keeping other programs' entries intact. */
export const dismissAnnouncement = (
  programId: string,
  announcement: ActiveProgramAnnouncement
): void => {
  LocalStorage.setItem(localStorageKeys.PROGRAM_ANNOUNCEMENT_DISMISSALS, {
    ...readDismissalMap(),
    [programId]: getAnnouncementSignature(announcement)
  });
};
